module.exports = __webpack_public_path__ + "ce74ea2e4c6080d7a2ed35bddbe0e74a.pdf";